import './components/slideshow/general.css';
export { default as Slide } from './components/slideshow/slide';
export { default as Fade } from './components/slideshow/fade';
export { default as Zoom } from './components/slideshow/zoom';
